import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface ArticleStructuredDataProps {
  title: string;
  description: string;
  imageUrl?: string;
  datePublished: string;
}

const ArticleStructuredData: React.FC<ArticleStructuredDataProps> = ({
  title,
  description,
  imageUrl = 'https://smartgastro.at/images/sG_fallback_small.jpeg',
  datePublished,
}) => {
  const location = useLocation();
  const fullUrl = `${typeof window !== 'undefined' ? window.location.origin : 'https://smartgastro.at'}${location.pathname}`;

  // Convert date from "DD.MM.YYYY" to ISO 8601 with Vienna time (noon, UTC+2)
  const parseDate = (dateStr: string): string => {
    const parts = dateStr.split('.');
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}T12:00:00+02:00`;
    }
    return `${dateStr}T12:00:00+02:00`;
  };

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    image: imageUrl,
    datePublished: parseDate(datePublished),
    dateModified: parseDate(datePublished),
    author: {
      '@type': 'Organization',
      name: 'smartGastro',
      url: 'https://smartgastro.at',
    },
    publisher: {
      '@type': 'Organization',
      name: 'smartGastro',
      logo: {
        '@type': 'ImageObject',
        url: 'https://smartgastro.at/logo192.png',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': fullUrl,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default ArticleStructuredData;
